import { render, staticRenderFns } from "./Game1-6.vue?vue&type=template&id=2e3090de&scoped=true&"
import script from "./Game1-6.vue?vue&type=script&lang=js&"
export * from "./Game1-6.vue?vue&type=script&lang=js&"
import style0 from "./Game1-6.vue?vue&type=style&index=0&id=2e3090de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3090de",
  null
  
)

export default component.exports